import styled from "@emotion/styled";
import { Checkbox } from "@ui-kit/Checkbox";

export const DiffCheckbox = styled(Checkbox)`
	width: 0.75rem;
	height: 0.75rem;

	svg {
		width: 0.75rem;
		height: 0.75rem;
		stroke-width: 3.5px;
	}
`;
